var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditPen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96,10.1l-5.9-5.9c-2.6-2.6-6-4-9.7-4c-3.7,0-7.1,1.4-9.7,4L14.4,60.3c-2,2-3.5,4.4-4.5,7.1L0.3,94.1 c-0.6,1.6-0.2,3.4,1,4.6c0.8,0.8,2,1.3,3.1,1.3c0.5,0,1-0.1,1.5-0.3l26.8-9.6c2.6-1,5.1-2.5,7.1-4.5L96,29.5 C101.3,24.1,101.3,15.4,96,10.1z M33.5,79.4c-1.1,1.1-2.4,1.9-3.8,2.4h0l-17.9,6.5l6.5-17.9c0.5-1.4,1.4-2.7,2.4-3.8l40.5-40.5 L74,38.9L33.5,79.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPen);
export default __webpack_public_path__ + "static/media/edit-pen.8587a5ae472be80c568fd4651e1df752.svg";
export { ForwardRef as ReactComponent };